import { render, staticRenderFns } from "./GestionePulsanti.vue?vue&type=template&id=7d95a281&scoped=true&"
import script from "./GestionePulsanti.vue?vue&type=script&lang=js&"
export * from "./GestionePulsanti.vue?vue&type=script&lang=js&"
import style0 from "./GestionePulsanti.vue?vue&type=style&index=0&id=7d95a281&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d95a281",
  null
  
)

export default component.exports